// START_MODULE utils_date_getdatetime_ts
// START_CONTRACT
// PURPOSE: Preserve this module from the original Tomsk Data Science frontend.
// OPERATIONAL_CONTEXT: Imported by the public static React application.
// CONTRACT: Keep the established layout, styling, and component behavior intact.
// KEYWORDS: legacy-frontend, static-site, tomsk-data-science
// COMPLEXITY: 2
// END_CONTRACT
export const getDateTime = (dateTime: string) => {
  const dateObj = new Date(dateTime);

  return `${dateObj.toLocaleDateString('ru-RU')} ${dateObj.toLocaleTimeString('ru-RU')}`;
};

// END_MODULE utils_date_getdatetime_ts
